export default __webpack_public_path__ + "static/char-s-61-zh-Hant-9a84307d6f288cd4d6ed989c2e129357.png";